<template>
  <div>
    <div class="search flex">
      <span class="tit">文章管理</span>
      <div class="flex">
        <el-button @click="toEventArticle()" size="mini" class="addBtn">文章操作日志</el-button>
        <el-button @click="toSystemArticle()" size="mini" class="addBtn">系统文章管理</el-button>
        <el-input class="addART"
                  placeholder="关键字" clearable
                  v-model="page.name"
                  @change="skipPage(1)"
                  suffix-icon="el-icon-search">
        </el-input>
      </div>

    </div>
    <div class="typeHead">
      <div class="medicineType flex">
        <span class="typeTit">文章分类：</span>
        <div class="medicineTypeL">
                    <span><label :class="active.type=='news'?'activeClass':''"
                                 @click="changePageType('news',0)">新闻资讯</label></span>
          <span><label :class="active.type=='science'?'activeClass':''"
                       @click="changePageType('science',0)">公益科普</label></span>
          <span><label :class="active.type=='research'?'activeClass':''"
                       @click="changePageType('research',0)">每日研究</label></span>
        </div>
      </div>
      <div class="medicineType flex">
        <span class="typeTit">状态：</span>
        <div class="medicineTypeL">
                    <span><label :class="active.status==1?'activeClass':''"
                                 @click="changePageType(1,1)">审核中</label></span>
          <span><label :class="active.status==2?'activeClass':''"
                       @click="changePageType(2,1)">审核通过</label></span>
          <span><label :class="active.status==3?'activeClass':''"
                       @click="changePageType(3,1)">审核拒绝</label></span>
        </div>
      </div>
    </div>
    <div class="instrument mt-5">
      <el-table :data="page.rows"
                class="record-table"
                :header-cell-style="{'background':'rgba(86,123,255,0.1)','color': '#666','fontWeight':'400','textAlign':'center'}"
                height="calc(100vh - 400px)"
                max-height="calc(100vh - 400px)">
        <el-table-column prop="doctorName" align="center" label="作者" width="120"></el-table-column>
        <el-table-column prop="publishDate" align="center" label="发布日期" width="100"
                         show-overflow-tooltip></el-table-column>
        <el-table-column prop="title" label="标题" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="status" align="center" label="状态" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.approveStatus == 1" class="yellow common">审核中</span>
            <span v-else-if="scope.row.approveStatus == 2" class="green common">审核通过</span>
            <span v-else-if="scope.row.approveStatus == 3"
                  class="pink common">{{ scope.row.status == 0 ? '审核拒绝' : '违规封禁' }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="viewsCount" align="center" label="阅读量" width="100"></el-table-column>
        <el-table-column prop="likesCount" align="center" label="点赞量" width="100"></el-table-column>
        <el-table-column prop="status" align="center" label="操作" width="180" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="scope.row.approveStatus==1" class="btn" @click="showApprove(scope.row.id)"
                       type="text"
                       size="small">审核
            </el-button>
            <!--todo-->
            <el-button v-if="scope.row.approveStatus==2" class="btn" type="text"
                       @click="showChangeStatus(scope.row.id,3)"
                       size="small">封禁
            </el-button>
            <el-button v-if="scope.row.approveStatus==3 && scope.row.status ==2" type="text"
                       @click="showChangeStatus(scope.row.id,2)" size="small" class="btn">解封
            </el-button>
            <el-button @click="viewDetails(scope.row)" type="text" class="btn" size="small">查看</el-button>
            <el-popover style="margin-left: 10px;"
                        @show="viewHistory(scope.row.id)"
                        placement="left"
                        width="800"
                        trigger="click">
              <el-table :data="logs" class="record-table"
                        max-height="400px"
                        :header-cell-style="{'background':'rgba(86,123,255,0.1)','color': '#666','fontWeight':'400','textAlign':'center'}">
                <el-table-column width="120" align="center" property="operator"
                                 label="操作人"></el-table-column>
                <el-table-column width="160" align="center" property="eventDate"
                                 label="时间"></el-table-column>
                <el-table-column width="100" align="center" property="operateCodeDesc"
                                 label="操作"></el-table-column>
                <el-table-column property="reason" align="center" label="原因" show-overflow-tooltip></el-table-column>
                <el-table-column width="100" property="remark" align="center" label="备注"
                                 show-overflow-tooltip></el-table-column>
              </el-table>
              <el-button slot="reference" type="text" size="small" class="btn">历史</el-button>
            </el-popover>

          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          class="pagination"
          background
          prev-text="Prev"
          next-text="Next"
          @current-change="skipPage"
          :current-page="page.current"
          :page-size="page.size"
          layout="prev, pager, next"
          :total="page.total">
      </el-pagination>
    </div>
    <!--审核-->
    <el-drawer title="文章审核" :visible.sync="approveDialog" :wrapperClosable="false" :close-on-press-escape="false"
               :show-close="false" size="600px" class="drawerCommon">
      <el-form v-loading="load" ref="form" :model="approve" label-suffix="："
               label-width="100px" class="maxHeight">
        <el-form-item label="审批结果">
          <el-radio-group v-model="approve.status">
            <el-radio label="2">通过</el-radio>
            <el-radio label="3">拒绝</el-radio>
            <el-checkbox v-model="record">记录文章</el-checkbox>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="意见/原因">
          <el-input type="textarea" rows="5" v-model="approve.reason" placeholder="请输入意见/原因（拒绝时必填）"/>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="approve.remark"></el-input>
        </el-form-item>
      </el-form>
      <div class="footer">
        <el-button type="primary" size="small" @click="submit">确定</el-button>
        <el-button size="small" @click="closeApprove">取消</el-button>
      </div>
    </el-drawer>
    <!--解封-->
    <el-drawer :title="'文章'+(banCondition.status==3?'封禁':'解封')" :visible.sync="banDialog"
               :wrapperClosable="false" :close-on-press-escape="false"
               :show-close="false" size="600px" class="drawerCommon">
      <el-form ref="form" :model="banCondition" label-suffix="："
               label-width="100px" class="maxHeight">
        <el-form-item label="意见/原因">
          <el-input type="textarea" rows="5" v-model="banCondition.reason" placeholder="请输入意见/原因"/>
        </el-form-item>
        <el-form-item label="">
          <el-checkbox v-model="record">记录文章</el-checkbox>
        </el-form-item>
      </el-form>
      <div class="footer">
        <el-button type="primary" size="small" @click="changeStatus">确定</el-button>
        <el-button size="small" @click="closeChangeStatus">取消</el-button>
      </div>
    </el-drawer>

  </div>
</template>

<script>
import base from '@/api/common';

export default {
  name: "pageList",
  data() {
    return {
      active: {
        type: 'news',
        status: 1,
      },
      urls: {
        news: base.manager_api.article.news.list,
        science: base.manager_api.article.science.list,
        research: base.manager_api.article.research.list,
      },
      details_urls: {
        news: base.manager_api.article.news.details,
        science: base.manager_api.article.science.details,
        research: base.manager_api.article.research.details,
      },
      page: {
        current: 1,
        size: 9,
        total: 24,
        rows: [],

        name: this.$route.query.name || ''
      },
      approveDialog: false,
      load: false,
      approve: {
        id: '',
        status: '2',
        reason: '',
        remark: ''
      },
      logs: [],
      record: true,

      banDialog: false,
      banCondition: {
        id: '',
        status: '',
        reason: '',
      },

    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    changePageType(value, type) {
      if (type === 0) {
        this.active.type = value;
      } else if (type === 1) {
        this.active.status = value;
      }
      this.page.current = 1;
      this.getData();
    },
    showApprove(id) {
      this.approve.id = id;
      this.approveDialog = true;
    },
    closeApprove() {
      this.approve.id = '';
      this.approve.status = '2';
      this.approve.reason = '';
      this.approve.remark = '';
      this.approveDialog = false;
    },
    viewDetails(row) {
      window.open("/admin/page/" + this.active.type + "/details/" + row.id, '_blank')
    },
    viewHistory(id) {
      this.logs = [];
      this.$ajax.get(base.manager_api.article.event_log.replace("{id}", id)).then((res) => {
        if (res.data.status === 'success') {
          this.logs = res.data.list;
        }
      });
    },
    getData() {
      this.$ajax.get(this.urls[this.active.type], {
        params: {
          approveStatus: this.active.status,
          name: this.page.name,
          page: this.page.current,
          size: this.page.size
        }
      }).then((res) => {
        if (res.data.status === 'success') {
          this.page.current = res.data.current;
          this.page.size = res.data.size;
          this.page.total = res.data.total;
          this.page.rows = res.data.rows;
        }
      })
    },
    skipPage(cur) {
      this.page.current = cur;
      this.getData();
    },
    submit() {
      if (this.approve.id) {
        if (this.approve.status == 3 && $.trim(this.approve.reason).length === 0) {
          this.$message.warning("拒绝时原因必填");
          return;
        }
        let url = base.manager_api.article[this.active.type].approve.replace("{record}", this.record);
        this.load = true;
        this.$ajax.post(url, this.approve).then((res) => {
          this.load = false;
          if (res.data.status === 'success') {
            this.removeItemById(this.approve.id);
            this.closeApprove();
            this.$message.success(res.data.message);
          } else {
            this.$message.error(res.data.message);
          }
        }).catch((err) => {
          console.error(err);
          this.$message.error("无法完成操作");
          this.load = false;
        });
      }
    },
    removeItemById(id) {
      let index;
      $(this.page.rows).each((i, o) => {
        if (o && o.id && o.id == id) {
          index = i;
          return false;
        }
      });
      if (index === 0 || index) {
        this.page.rows.splice(index, 1);
      }
    },
    showChangeStatus(id, status) {
      this.banCondition.id = id;
      this.banCondition.status = status;
      this.banDialog = true;
    },
    closeChangeStatus() {
      this.banCondition.id = '';
      this.banCondition.status = '2';
      this.banCondition.reason = '';
      this.banDialog = false;
    },
    changeStatus() {
      let that = this;
      let url = base.manager_api.article[this.active.type].changeStatus.replace("{record}", this.record);
      this.$ajax.post(url, this.banCondition)
          .then((res) => {
            if (res.data.status === 'success') {
              that.removeItemById(this.banCondition.id);
              that.closeChangeStatus();
              that.$message.success(res.data.message);
            } else {
              that.$message.error(res.data.message);
            }
          }).catch((err) => {
        console.error(err);
        that.$message.error("操作失败");
      });
    },
    toEventArticle() {
      this.$router.push({path: '../event/list', query: {type: 'event_article'}})
    },
    toSystemArticle() {
      this.$router.push({path: '../systemArticle/list'})
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../../assets/css/admin.scss';

</style>
